import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup } from 'reactstrap';
import { Dropdown } from '@ami/react/core';
import { ListGroup, ListGroupEmptyItem, ListGroupItem } from '@ami/react/core';
import { allExceptIds } from '@ami/react/core';
import { DealerUserSearchResult } from '../dealer-users/dealerUserService';

const NoOptions = ({ show }) =>
  show && <ListGroupEmptyItem>None configured</ListGroupEmptyItem>;

export class DealerUserMultipleSelection extends Component {
  constructor(props) {
    super(props);
    this.removeItem = this.removeItem.bind(this);
    this.addItem = this.addItem.bind(this);
    this.getAvailableDealerUsers = this.getAvailableDealerUsers.bind(this);
  }

  static propTypes = {
    dealerUsers: PropTypes.arrayOf(PropTypes.instanceOf(DealerUserSearchResult))
      .isRequired,
    dealerUserIds: PropTypes.array.isRequired,
    onUpdate: PropTypes.func.isRequired,
    fieldLabel: PropTypes.string.isRequired,
  };

  removeItem(id) {
    this.props.onUpdate(this.props.dealerUserIds.filter((x) => x !== id));
  }

  addItem(selectedId) {
    if (!selectedId) return;
    this.props.onUpdate([...this.props.dealerUserIds, selectedId]);
  }

  getAvailableDealerUsers() {
    return allExceptIds(this.props.dealerUsers, this.props.dealerUserIds);
  }

  render() {
    const renderListItems =
      this.props.dealerUserIds &&
      this.props.dealerUserIds.length > 0 &&
      this.props.dealerUsers.length > 0;
    return (
      <FormGroup>
        <ListGroup label={this.props.fieldLabel}>
          {renderListItems &&
            this.props.dealerUserIds.map((id) => {
              const option = this.props.dealerUsers.find((x) => x.id === id);
              return (
                <ListGroupItem
                  heading={option.label}
                  onRemove={() => this.removeItem(id)}
                  key={id}
                />
              );
            })}
          <NoOptions show={this.props.dealerUserIds.length === 0} />
        </ListGroup>
        <Dropdown
          placeholder="Select a dealer contact..."
          items={this.getAvailableDealerUsers()}
          onChange={this.addItem}
          className="w-full"
        />
      </FormGroup>
    );
  }
}
